 
export default {
  primary: {
    50: "#E6DCC6",
    100: "#E0D3B8",
    200: "#DACBAA",
    300: "#D3C29C",
    400: "#CDB98E",
    500: "#C7B180",
    600: "#C1A871",
    700: "#BB9F63",
    800: "#B49655",
    900: "#AA8C4B",
  },
  secondary: "#293F51",
  text: "#0C0B18",
  background: "#FAFAFA",
  grayBg: "#F3F3F3FC",
  error: "#E84A4A",
  success: {
    100: "rgba(133, 203, 51, 0.2)",
    400: "#85CB33",
    500: "#85CB33",
    800: "#85CB33",
  },
  yellow: {
    100: "rgba(255, 184, 49, 0.2)",
    400: "#FFB831",
    500: "#FFB831",
    800: "#FFB831",
  },
  heading: "#33263E",
  placeholder: "#c1c1c1",
};
